import { segments } from "@/lib/email";
import { cn } from "@/lib/utils";

/** Classes of a token chip, by namespace. */
export function tokenClass(token: string): string {
  const namespace = token.replace(/[{}\s]/g, "").split(".")[0];
  if (namespace === "contact") return "bg-sky-50 text-sky-700 ring-sky-200/70";
  if (namespace === "company") return "bg-violet-50 text-violet-700 ring-violet-200/70";
  if (namespace === "ai" || namespace === "prepared" || namespace.startsWith("ia_") || namespace === "preuves_sociales") return "bg-fuchsia-50 text-fuchsia-700 ring-fuchsia-200/70";
  return "bg-slate-100 text-slate-600 ring-slate-200";
}

/** A template as text with its `{{tokens}}` as chips; malformed ones in red. */
export function TemplateText({
  template,
  className,
  empty = "—",
  unresolved = false,
}: {
  template: string;
  className?: string;
  empty?: string;
  /** A rendered email: any token left is a value that is missing. */
  unresolved?: boolean;
}) {
  if (!template.trim()) return <span className={cn("italic text-slate-400", className)}>{empty}</span>;
  return (
    <span className={className}>
      {segments(template).map((segment, index) =>
        segment.kind === "text" ? (
          <span key={index}>{segment.value}</span>
        ) : (
          <span
            key={index}
            className={cn(
              "mx-px inline-block rounded px-1 py-px font-mono text-[0.82em] leading-tight ring-1 ring-inset",
              segment.kind === "bad"
                ? "bg-rose-50 text-rose-600 ring-rose-200 line-through decoration-rose-300"
                : unresolved
                  ? "bg-rose-50 text-rose-600 ring-rose-200"
                  : tokenClass(segment.value),
            )}
          >
            {segment.value.replace(/^\{\{\s*|\s*\}\}$/g, "")}
          </span>
        ),
      )}
    </span>
  );
}
